import { Directive, ElementRef, EventEmitter, HostListener, Output, inject } from '@angular/core';

@Directive({
  selector: '[appGlobalSearch]'
})
export class GlobalSearchDirective {
  private readonly elementRef = inject(ElementRef);
  
  @Output() openSearch = new EventEmitter<void>();

  @HostListener('document:keydown', ['$event'])
  handleKeyboardShortcut(event: KeyboardEvent): void {
    const isMac = navigator.userAgent.includes('Macintosh');
    const isShortcut = (isMac && event.metaKey && event.key === 'k') ||
                      (!isMac && event.ctrlKey && event.key === 'k');

    if (isShortcut) {
      event.preventDefault();
      this.openSearch.emit();
    }
  }
}
